import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { ProductViewModalComponent } from '../product/product-view-modal/product-view-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
@Component({
  selector: 'app-available-networklocations',
  templateUrl: './available-networklocations.component.html',
  styleUrls: ['./available-networklocations.component.scss']
})
export class AvailableNetworklocationsComponent implements OnInit {
  @Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  AvailableProducts: any[];
  selectedProducts: any[] = [];
  mappedProducts: any[] = [];
  screenheading: any = "";
  selectedProductsNet: any[] = [];
  constructor(
    private modalService: NgbModal,
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    public commonService: CommonService
  ) { }
  ngOnInit() {
    this.screenheading = "Available Network Locations";
    this.getNetworkLocations();
    this.selectedProducts = this.Content.content.mappedIds;

  }

  checkSelected() {
    this.AvailableProducts.forEach((item: any) => {
      if (this.selectedProducts.findIndex(x => x == item.Value) != -1) {
        item.isSelected = true;
      }
      else {
        item.isSelected = false;

      }

    })
  }

  getSelectdOrNot(item) {
  }
  SaveMapping() {

    var selectedValues = "";
    if (this.selectedProducts != undefined && this.selectedProducts.length > 0) {
      this.selectedProducts.forEach(obj => {
        var Mapobj = this.AvailableProducts.filter(function (element) {
          return element.Value == obj;
        })[0];
        if (Mapobj != null && Mapobj != undefined) {
          this.mappedProducts.push(Mapobj);
        }

      });

      var data = new FormData();
      data["TransactionID"] = this.Content.content.id;
      data["clsificationType"] = selectedValues;
      this.modalRef.close(this.mappedProducts);

    }
    else {
      this.commonService.ValidationBanner("Please select Network Location");
    }
  }
  CollectItem(event, item) {
    if (this.selectedProducts.indexOf(item.Value) > -1) {
      this.selectedProducts.splice(this.selectedProducts.indexOf(item.Value), 1);
    }
    else {
      this.selectedProducts.push(item.Value);
    }
  }
  getNetworkLocations() {
    this.summaryService.getRecord('api/ProductNetworkLocations/GetNetworkLocations?RecordID=' + this.Content.content.id).subscribe(summary => {
      this.AvailableProducts = summary as [];
      this.checkSelected();
    });
  }

}
